import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ModalComponent from '../components/modal';

import BannersAction from '../app/store/actions/banners';

import Notification from '../components/notifications';
import itemsPage from '../data/itemsPage';
import Select from '../components/form/select';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class BannersPage extends Component {
  constructor(props) {
    super(props);
    this.orderedBanners = []
    this.state = {
      limit: itemsPage.page.limit,
      show: false,
      page: 1,
      search: '',
      showModal: false,
      showModalOrder: false,
      countActiveBanners: 0,
      orderBy: 'ASC',
      field: 'id',
      position: {},
      oldPosition: {},
    };
    this.translationURL = {
      ACTION_OPEN_HOME: I18n.t('screenHome'),
      ACTION_OPEN_PRODUCTS: I18n.t('screenProduct'),
      ACTION_OPEN_CART: I18n.t('screenCart'),
    };
    this.translationDisplayOn = {
      web: I18n.t('web'),
      webMobile: I18n.t('webMobile'),
      app: I18n.t('app'),
    };
    this.instanceTimeout = null;
  }

  componentDidMount() {
    this.searchBanners();
  }

  componentWillUnmount() {
    clearTimeout(this.instanceTimeout);
    this.setNewPositionUpdateBanner();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchBanners();
  }

  getTypeBanner = (type) => {
    switch (type) {
      case 2:
        return I18n.t('greenPortfolio');
      case 3:
        return I18n.t('projectsForIntegrators');
      case 4:
        return I18n.t('offer');
      default:
        return I18n.t('bannersMain');
    }
  }

  searchBanners = async () => {
    const {
      search, page, limit, orderBy, field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    await this.props.getBanners(limit, skip, search, orderBy, field);
    const position = {};
    if (this.props.banners.rows) {
      for (const elem of this.props.banners.rows) {
        if (elem.posicion) position[elem.id] = elem.posicion;
      }
      this.setState({
        position: { ...this.state.position, ...position },
        oldPosition: { ...this.state.oldPosition, ...position }
      });
    }
  }

  deleteBannerModal = async (bannerId) => {
    await this.setState({ selectItemToDelete: bannerId, showModal: true });
  }

  deleteBanner = async () => {
    const { selectItemToDelete } = this.state;

    if (selectItemToDelete) {
      await this.props.deleteBanner(selectItemToDelete);
      await this.setState({ selectItemToDelete: undefined, showModal: false });
      await this.searchBanners();
      this.deleteNotification();
    }
  }

  setNewPositionUpdateBanner = () => {
    const positionArray = [];
    const oldPosition = this.state.oldPosition;
    for (const key in this.state.position) {
      if (this.state.position[key] !== oldPosition[key]) {
        positionArray.push({ id: key, position: this.state.position[key] });
        oldPosition[key] = this.state.position[key];
      }
    }
    this.props.updateBanner({ positionArray }, true)
  }

  setNewPosition = (fieldId, fieldValue) => {
    if (!isNaN(fieldValue) && fieldValue.length <= 3 && (!fieldValue || Number(fieldValue) > 0)) {
      clearTimeout(this.instanceTimeout);
      this.setState({
        position: {
          ...this.state.position,
          [fieldId]: fieldValue,
        }
      })
      this.instanceTimeout = setTimeout(() => {
        this.setNewPositionUpdateBanner();
        this.setState({ oldPosition });
      }, 2000);
    }
  }

  deleteNotification = () => {
    this.setState({ show: true });
    setTimeout(() => { this.setState({ show: false }); }, 5000);
  }

  active = async (active, id) => {
    const { settings } = this.props;
    const { companyTag = '' } = settings;
    if (companyTag === 'nortel' && !active) {
      await this.props.updateBanner({ nullPosition: true, active, id });
    } else {
      await this.props.updateBanner({ active, id })
    }
    await this.searchBanners();
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchBanners();
  }

  updateOrderedBanners = async () => {
    await this.props.updateBanner({ positionArray: this.orderedBanners });
    this.setState({ showModalOrder: false })
    await this.searchBanners();
  }

  setValue = (value, index) => {
    if (this.orderedBanners.length && value) {
      const orderedBannersChecks = this.orderedBanners.filter(element => element.id === value.id)
      if (orderedBannersChecks.length) {
        this.setState({
          [`banners${orderedBannersChecks[0].index + 1}`]: '',
          [`banners${index + 1}`]: value
        })
        this.orderedBanners.splice(this.orderedBanners.findIndex(element => element.id === value.id), 1, { index, id: value.id })
      } else {
        const posi = this.orderedBanners.findIndex((element) => element.index === index)
        if (posi >= 0) this.orderedBanners.splice(posi, 1, { index: null, id: this.orderedBanners[posi].id })
        this.orderedBanners.push({ index, id: value.id })
        this.setState({ [`banners${index + 1}`]: value })
      }
    } else {
      if (!value) {
        const posi = this.orderedBanners.findIndex((element) => element.index === index)
        if (posi >= 0) this.orderedBanners.splice(posi, 1, { index: null, id: this.orderedBanners[posi].id })
      } else {
        this.orderedBanners.push({ index, id: value.id });
      }
      this.setState({
        [`banners${index + 1}`]: value || ''
      })
    }
  }

  getOptions = () => {
    const { activeBanners } = this.state;
    const options = activeBanners.map(element => ({ label: `${element.id} - ${element.name}`, id: element.id }))
    return options
  }

  renderOrders = () => {
    if (this.state.countActiveBanners < 1) {
      return (
        <div className="form-main">
          <div className="row d-flex justify-content-center pt-4">
            <h4> <Translate value="orderingBanners" /> </h4>
          </div>
          <div className="row d-flex justify-content-center mt-4">
            <h5>
              <Translate value="bannersCurrentlyActive" />
            </h5>
          </div>
          <div className="row d-flex justify-content-center mt-4">
            <button
              type="button"
              className="btn btn-warning mt-4"
              onClick={() => this.setState({ showModalOrder: false })}
            >
              <Translate value="ok" />
            </button>
          </div>
        </div>
      )
    }
    return (
      <div className="form-main ">
        <div className="row d-flex justify-content-center pt-4">
          <h4> <Translate value="orderingBanners" /> </h4>
        </div>
        <form >
          <div style={{ maxHeight: 400, overflowY: 'auto' }}>
            {(this.state.activeBanners || []).map((element, index) => (
              <div style={{ margin: '1rem' }} key={`${element.id}`}>
                <p className="margin-bottom-2">
                  {`${index + 1}º `}
                  <Translate value="banner" />
                </p>
                <Select
                  value={this.state[`banners${index + 1}`] || ''}
                  onChange={value => this.setValue(value, index)}
                  options={this.getOptions() || []}
                  isClearable
                  placeholder={<Translate value="selectBanner" />}
                />
              </div>
            ))}
          </div>
          <div className="row d-flex justify-content-center mt-4">
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => this.setState({ showModalOrder: false })}
            >
              <Translate value="cancel" />
            </button>
            <button
              type="button"
              className="btn btn-primary ml-3"
              onClick={() => this.updateOrderedBanners()}
            >
              <Translate value="save" />
            </button>

          </div>
        </form>
      </div>
    )
  }

  showOrdersModal = () => {
    const { banners } = this.props;
    const activeBanners = (banners.rows || []).filter(element => element.active === true)

    if (activeBanners.length) {
      for (let index = 0; index < activeBanners.length; index++) {
        const element = activeBanners[index];
        const orderedBannersChecks = this.orderedBanners.filter(elem => elem.id === element.id)
        if (orderedBannersChecks.length) {
          if (orderedBannersChecks && orderedBannersChecks[0].index) {
            this.setState({
              [`banners${orderedBannersChecks[0].index + 1}`]: ''
            })
          }
          this.orderedBanners.splice(this.orderedBanners.findIndex(elem => elem.id === element.id), 1)
        }
        if (element.posicion !== null) {
          this.orderedBanners.push({ index: element.posicion, id: element.id })
          this.setState({ [`banners${element.posicion + 1}`]: { label: `${element.id} - ${element.name}`, id: element.id } })
        }
      }
    }
    this.setState({
      activeBanners,
      countActiveBanners: activeBanners.length,
      showModalOrder: true,
    });
  }

  formatRedirectUrl = (elements) => {
    if (elements.displayOn === 'app' && elements.redirectUrl) {
      const { urlInternal } = JSON.parse(elements.redirectUrl);
      return this.translationURL[urlInternal];
    }
    return elements.redirectUrl;
  }

  render() {
    const {
      limit, show, page, showModal, showModalOrder, countActiveBanners,
    } = this.state;
    const { banners = {}, settings } = this.props;
    const { companyTag = '' } = settings;

    const tableHeader = [
      { key: 'id', value: 'ID' },
      { key: 'name', value: I18n.t('name') },
      { key: 'redirectUrl', value: I18n.t('redirectUrl') },
      { key: 'description', value: I18n.t('description') },
      { key: 'displayOn', value: I18n.t('displayOn') },
      { key: 'typeBanner', value: I18n.t('typeBanner') },
      { key: 'posicion', value: I18n.t('position') },
      { key: 'active', value: I18n.t('active') },
      { key: 'action', value: I18n.t('action') },
    ];

    const renderData = (row, index) => {
      return {
        key: index,
        id: row.id,
        name: row.name,
        redirectUrl: this.formatRedirectUrl(row),
        description: row.description,
        displayOn: this.translationDisplayOn[row.displayOn],
        typeBanner: this.getTypeBanner(row.typeBanner),
        posicion: (
          <div style={{ width: '55px' }}>
            <input
              type="text"
              disabled={!row.active}
              key={`input${row.id}`}
              className="form-control"
              value={this.state.position[row.id] || ''}
              onChange={(e) => this.setNewPosition(row.id, e.target.value)}
            />
          </div>
        ),
        active: (
          <div className="row margin-left-0">
            <button
              type="button"
              className={`btn btn-${row.active ? 'warning' : 'dark'} promotion-btn-${row.active ? 'warning' : 'active'}`}
              onClick={() => this.active(!row.active, row.id)}
            >
              <Translate value={row.active ? 'disable' : 'active'} />
            </button>
          </div>
        ),
        action: (
          <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
            <div className="btn-group" role="group">
              <button
                id="btnGroupDrop1"
                type="button"
                className="btn btn-secondary dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <Translate value="action" />
              </button>
              <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <button
                  type="button"
                  className="dropdown-item dropdown-table"
                  onClick={() => history.push({
                    pathname: ROUTES.BANNERS_FORM,
                    search: `?id=${row.id}`,
                  })}
                >
                  <Translate value="edit" />
                </button>
                <button
                  type="button"
                  className="dropdown-item dropdown-table"
                  onClick={() => this.deleteBannerModal(row.id)}
                >
                  <Translate value="delete" />
                </button>
                <button
                  type="button"
                  className="dropdown-item dropdown-table"
                  onClick={() => this.props.getBannerImage(row.imageUrl)}
                >
                  <Translate value="download" />
                </button>
              </div>
            </div>
          </div>
        ),
      }
    };

    const tableData = (banners.rows || []).map(renderData);

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.BANNERS_FORM }} />
        <button
          onClick={() => history.push(ROUTES.UPLOAD_BANNERS)}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="import" />
        </button>

        <button
          onClick={() => this.props.getCsvBannersReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
        {companyTag === 'nortel' && (
          <button
            onClick={() => this.showOrdersModal()}
            type="button"
            className="btn btn-secondary margin-left-10">
            <Translate value="saveOrder" />
          </button>
        )}
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">

        <ModalComponent
          title={I18n.t('delete')}
          body="Deseja realmente excluir o banner?"
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px' }}
          showButtons
          showCancel
          confirmModal={this.deleteBanner}
        />

        <Table
          title={I18n.t('banners')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={banners.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />

        {show && <Notification classe="success" message={I18n.t('productDeleted')} />}

        {companyTag === 'nortel' && (
          <ModalComponent
            showButtons={false}
            visible={showModalOrder}
            closeModal={() => this.setState({ showModalOrder: false })}
            type="orderCategory"
            size={{ width: '40%' }}
            bodyFuncComponent={() => this.renderOrders()}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getBanners: (limit, skip, search, order, field) => dispatch(
    BannersAction.getBanners(limit, skip, search, order, field),
  ),
  updateBanner: (banner, noLoading = false) => dispatch(BannersAction.updateBanner(banner, noLoading)),
  deleteBanner: id => dispatch(BannersAction.deleteBanner(id)),
  getCsvBannersReport: () => dispatch(BannersAction.getCsvBannersReport()),
  getBannerImage: fileUrl => dispatch(BannersAction.getBannerImage(fileUrl)),
});

const mapStateToProps = state => ({
  banners: state.banners && state.banners.banners,
  settings: state.settings,
});

export default connect(mapStateToProps, mapDispatchToProps)(BannersPage);
